import { useFetchPlanPackageUserFieldsQuery } from "queries/planPackage.queries";
import { useRef } from "react";
import { getFieldsValidation } from "./useTenantUserFields";

export default function usePlanPackageUserFields(
  planPackageId: number | undefined
) {
  const fieldRefs = useRef<Array<any>>([]); // An array that contains all custom planPackage's fields' ref
  const { data: planPackageUserFields } =
    useFetchPlanPackageUserFieldsQuery(planPackageId);

  const planPackageFieldsValidation = getFieldsValidation(
    planPackageUserFields
  );

  return {
    planPackageUserFields,
    planPackageFieldsValidation,
    fieldRefs,
  };
}
